module.exports = __webpack_public_path__ + "assets/img/price-role.ef94b952.png";